import React from "react";
import { Outlet } from "react-router-dom";
import Header from "./Header";
// import Hero from "./Hero";
import Footer from "./Footer";

const Layout = ({ children }) => {
  return (
    <>
      <Header />
      {/* <Hero /> */}
      <Outlet />
      <Footer />
    </>
  );
};

export default Layout;